<template>
    <v-dialog v-model="modal" max-width="600px" persistent overlay-opacity="1">
        <v-card>
            <v-card-title primary-title> 
                <v-avatar :tile="true">
                    <v-img src="@/assets/skg-logo.png" aspect-ratio="1" ></v-img>
                </v-avatar>
                <v-divider vertical class="pl-2 pr-2"></v-divider>&nbsp;
                <b>เข้าสู่ระบบ Security</b> </v-card-title>            
            <v-card-text>
                <v-container>
                    <v-alert
                        v-model="isError"
                        dense
                        color="red lighten-1"
                        dismissible
                        >{{errorMessage}}
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field ref="userName" required label="ชื่อผู้ใช้" autofocus v-model="userName"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field required label="รหัสผ่าน" type="password" v-model="password" @keyup.enter.native="doLogin"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-on:click="doLogin">ตกลง</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/* eslint-disable */

import {login} from '@/api/authen-api.js'
import {getUser} from '@/assets/js/common.js'

export default {
    name: 'Login',
    data() {
        return {
            modal: true,
            userName: '',
            password: '',
            isError: false,
            errorMessage: '',
            onClose: ''
        }
    },
     methods : {
        doLogin() {
            if (this.userName === undefined || this.userName.length <= 0) {
                this.showErrror("กรุณาระบุชื่อผู้ใช้");
                return;
            }
            this.$loading(true);
        
            login(this.userName, this.password).then(response => {
                if (response.status != 1) {
                    this.showErrror(response.data);
                    return;
                } 
                //this.currUser = getUser(response.data.data);
                this.doClose();
                
            }).catch(e => {
                this.showErrror(e);
            });
        },
        showErrror(message) {
            this.isError = true;
            this.errorMessage = message;
            this.$loading(false);
        },
        doClose() {
            this.modal = false;
            this.$emit("close", this.userName, true);
            this.$loading(false);
            
        }
    }
}
</script>